(function(){
    'use strict';

    angular
    .module('appback')
    .controller('ImpresionController', ImpresionController)
 
    ImpresionController.$inject = ["GenerallabService","ListasService","$http","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function ImpresionController(GenerallabService,ListasService,$http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this; 

        vm.printService = new WebSocketPrinter();
        vm.impresas = {};
        vm.lab_id = "";
        vm.determinacion = "";
        vm.tipoetiqueta = "";
        vm.listaImpresion = [{ lims_id:'', cantidad:1}];
        vm.imprimirEtiquetasCustom = function(){
        vm.impresas = {};
             vm.impresas[vm.idregprint] = {value:true, id:'', cantidad: vm.cantreg, determinacion:vm.determinacion};

             ListasService.imprimirEtiquetas(vm.impresas,vm.categoria_id,vm.subcategoria,vm.lab_id,vm.tipoetiqueta,function(data){
                vm.printRaw(data.print);
                //location.reload();
                ////console.log(data);
            });
        }

        // MODIFICAMOS EL GRID ALL BUTTON
        vm.initImpresion = function(){
            $('.select-on-check-all').on("click",function(){
                //console.log("E");
                //console.log("sele",($(this).is(":checked") ? 1 : 0));
                var self = $(this);
                angular.forEach(vm.seleccionadas, function (value, key) {
                    $timeout(function(){
                        vm.seleccionadas[key] = (self.is(":checked") ? 1 : 0);
                    })
                });
            })
        }
        

        vm.printRaw = function(value) {
            vm.printService.submit({
                'type': 'INVOICE',
                'raw_content': value
            });
        };
        vm.contadorImpresas = function(){
            var cont = 0;
            angular.forEach(vm.seleccionadas, function (value, key) {
                if(value==1){
                    cont++;
                }
            });
            return cont;
            //return Object.keys(vm.seleccionadas).length;
        }

        vm.imprimirLista = function(){
            var impresas = {};
            for(var cont=0;cont<vm.listaImpresion.length;cont++){
                impresas[vm.listaImpresion[cont].lims_id] = {id:'',cantidad:vm.listaImpresion[cont].cantidad,value:true};
            }

            ListasService.imprimirEtiquetasLista(impresas,vm.tipoetiqueta,function(data){
                vm.printRaw(data.print);
            });
        }

        vm.configurarCor = function(){
            vm.listaImpresion = [];
            if(!isNaN(vm.cantidadeti) && vm.cantidadeti > 0){
                for(var cont=0;cont<vm.cantidadeti;cont++){
                    vm.listaImpresion.push({lims_id:vm.inicial+cont,cantidad:1});
                }
            }
        }

        vm.addLista = function(){
            vm.listaImpresion.push({ lims_id:'',cantidad:1 });


        }
        vm.addFecha = function(imp,fecha,index){
            imp.lims_id = fecha;
            $('.lims_id_'+index).focus();
        }
        vm.imprimirEtiquetas = function(){
           vm.impresas = {};
           $('input[name^="prueba"]').each(function(){
                var lims_id = $(this).attr("lims_id");
                var peticion_id = $(this).attr("peticion_id");
                if($(this).is(":checked")){
                    if(typeof(lims_id)!='undefined'){
                        vm.impresas[lims_id] = {value:true, id:peticion_id, cantidad: $('input[name="cantidad['+lims_id+']"]').val()};
                    }
                } 
            });

           console.log("impresas",vm.impresas);

            ListasService.imprimirEtiquetas(vm.impresas,vm.categoria_id,vm.subcategoria,vm.lab_id,vm.tipoetiqueta,function(data){
                console.log("data imprimir etiquetas",data);
                vm.printRaw(data.print);
                location.reload();
                ////console.log(data);
            });
        }

        vm.imprimirEtiquetasAntibiogramas = function(){
            vm.impresas = {};
            $('input[name^="prueba"]').each(function(){
                 var id = $(this).attr("id");
                 var peticion_id = $(this).attr("peticion_id");
                 if($(this).is(":checked")){
                     if(typeof(id)!='undefined'){
                         vm.impresas[id] = {value:true, peticion_id:peticion_id, cantidad: $('input[name="cantidad['+id+']"]').val()};
                     }
                 }
             });
            console.log("impresas",vm.impresas);
             console.log("datos a enviar", vm.impresas, vm.categoria_id, vm.subcategoria, vm.lab_id, vm.tipoetiqueta);
             ListasService.imprimirEtiquetasAnti(vm.impresas,vm.categoria_id,vm.subcategoria,vm.lab_id,vm.tipoetiqueta,function(data){
                console.log("data imprimir etiquetas antibiogramas", data);
                 vm.printRaw(data.print);
                 location.reload();
             });
         }


    }
  
})();